import { Component } from "@angular/core";
import { Event, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { LoaderService } from "src/app/Services/LoaderService/loader.service";
import { UserConfigService } from "src/app/Services/AuthService/user-config.service";
import { CookieService } from "ngx-cookie-service";
import { lyl, StyleRenderer, ThemeRef, ThemeVariables } from "@alyle/ui";
import { UserDetailsService } from "./Components/Services/user-details.service";
import { environment } from "src/environments/environment";
import { EAccountType } from "./Models/Enum/account-type";
import AOS from "aos";

declare let $: any;
const STYLES = (theme: ThemeVariables, ref: ThemeRef) => {
  const __ = ref.selectorsOf(STYLES);
  return {
    $global: lyl`{
      body {
        background-color: ${theme.background.default}
        color: ${theme.text.default}
        font-family: ${theme.typography.fontFamily}
        margin: 0
        direction: ${theme.direction}
      }
    }`,
    root: lyl`{
      display: block
    }`,
  };
};

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [StyleRenderer],
})
export class AppComponent {
  readonly classes = this.sRenderer.renderSheet(STYLES, true);

  title = "MarihubMarketPlace";
  currentUrl: string = "";

  constructor(
    readonly sRenderer: StyleRenderer,
    public router: Router,
    private loaderService: LoaderService,
    private userConfigService: UserConfigService,
    private userDetailsService: UserDetailsService,
    private cookieService: CookieService
  ) {
    this.getUser();
  }

  ngOnInit(): void {
    AOS.init(
      {
        easing: 'ease-out-cubic',
        once: true,
        duration: 1000,
      }
    );

        
        

    this.router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.loaderService.show();
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        this.loaderService.hide();
        if (
          this.userDetailsService.user.accountTypeCode ===
          EAccountType.BUYER_PORTAL
        ) {
          if (environment.production) {
            $.getScript("../assets/JS/google-analytics.js");
          }
        }
      }
      window.scrollTo(0, 0);
    });
    if (this.userDetailsService.user.isLoggedIn) {
      $.getScript("../assets/JS/TawkTo.js");
    }
  }

  getUser(): void {
    if (sessionStorage.getItem("token")) {
      this.userConfigService.setUserConfig({
        accountId: Number(sessionStorage.getItem("accountId")),
        isSuperAdmin: sessionStorage.getItem("isSuperAdmin"),
        accountTypeCode: String(sessionStorage.getItem("accountTypeCode")),
        name: String(sessionStorage.getItem("fullName")),
        companyName: String(sessionStorage.getItem("companyName")),
        profileImg: sessionStorage.getItem("profilePicturePath"),
        currencyCode: String(sessionStorage.getItem("currencyCode")),
        isLoggedIn: true,
        token: String(sessionStorage.getItem("token")),
        emailAddress: String(sessionStorage.getItem("emailAddress")),
        currencyId: Number(sessionStorage.getItem("currencyId")),
        userId: Number(sessionStorage.getItem("userId")),
        roleCode: String(sessionStorage.getItem("roleCode")),
        roleId: Number(sessionStorage.getItem("roleId")),
        // @ts-ignore
        userPermissionsLists: JSON.parse(
          sessionStorage.getItem("userPermissionsLists")!
        ),
        // @ts-ignore
        displayBoardingVideo: JSON.parse(
          sessionStorage.getItem("displayBoardingVideo")!
        ),
      });
    } else if (this.cookieService.get("token")) {
      this.userConfigService.setUserConfig({
        accountId: Number(this.cookieService.get("accountId")),
        isSuperAdmin: this.cookieService.get("isSuperAdmin"),
        accountTypeCode: this.cookieService.get("accountTypeCode"),
        name: this.cookieService.get("fullName"),
        companyName: this.cookieService.get("companyName"),
        token: this.cookieService.get("token"),
        profileImg: this.cookieService.get("profilePicturePath"),
        currencyCode: this.cookieService.get("currencyCode"),
        isLoggedIn: true,
        emailAddress: this.cookieService.get("emailAddress"),
        currencyId: Number(this.cookieService.get("currencyId")),
        userId: Number(this.cookieService.get("userId")),
        roleCode: this.cookieService.get("roleCode"),
        roleId: Number(this.cookieService.get("roleId")),
        userPermissionsLists: JSON.parse(
          this.cookieService.get("userPermissionsLists")
        ),
        displayBoardingVideo: JSON.parse(
          this.cookieService.get("displayBoardingVideo")
        ),
      });
    } else {
      this.userConfigService.setUserConfig({
        name: "",
        profileImg: "",
        isSuperAdmin: null,
        accountTypeCode: "",
        companyName: "",
        token: "",
        isLoggedIn: false,
        emailAddress: "",
        currencyCode: "",
        accountId: null,
        currencyId: null,
        userId: null,
        roleCode: "",
        roleId: null,
        userPermissionsLists: [],
        displayBoardingVideo: false,
      });
    }
  }
}
